export const LSystem = {
    // Header
    title:"L-System Tree Generator",
    subtitle:"Python | Blender",
    genre:"",

    //Hero
    poster:"/Thumbnails/L-Sys_Thumbnail.png",
    releaseDate:"",
    studioName:"",
    teamSize:"3",
    platforms:"PC",
    responsiblities:["Worked on connecting the Python script to Blender via Visual Studio Code",],
    engine:"",
    projectLength:"2 Weeks",

    //Description
    desc:[`The Visual Studio Code extension "Blender Development" by Jacques Lucke is required to properly connect the program to Blender

        Open the folder titled Module in VS Code and open "inputbox.py", Press Ctrl+Shift+P and run "Blender: Start" pick your version of Blender to open

        Open the given demo tree in L-SystemDemo.blend or create your own`,

        `press Ctrl+Shift+P again and run "Blender: Run Script"`,

        `Follow the images to open the L-System interaction screen, Either clear the current tree or input your own L-System to generate a fresh tree!`

    ],
    img:["/Software/L-System Generator/L-Sys_Thumbnail.png", "/Software/L-System Generator/L-Sys_OpenBlender.png", 
        "/Software/L-System Generator/L-Sys_Step1.jpg", "/Software/L-System Generator/L-Sys_Step2.png"
        
    ],

    contributions:[

    ],

    //Home Screen Hero
    thumbnail:"./Thumbnails/L-Sys_Thumbnail.png",
    shortDesc:`Python script interacting with Blender to generate a "Tree" based off of an L-System instruction.`,
    badge:"./Project Badges/python-&-blender-l-systems.svg",
    url:"/projects/L-System Generator",
    type:"Software",


    //Special Sections
    downloadable:".",
    credits:"",
    awards:"",
    awardImg:[

    ],
    software:"yes",



    //L-System
    special:"yes",
    specialText:[

    ],

    //Links
    githubURL:"https://github.com/DrakeMitchell/L-SystemTree",
    itchioURL:"",
    itchioEmbedURL:"",
    steamURL:"",


}